import * as qs from 'query-string';
import * as moment from 'moment';
import * as _ from 'lodash';
import React, { Component, FormEvent, HTMLInputTypeAttribute } from 'react';
import { Button, FormControl, Row, Col, Alert, DropdownButton, MenuItem, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FilterWrapper } from './styles';
import { IInvoiceTransplantRequest } from '@nkr/store/index';
import { InvoiceTransplantStatus, OrganType } from '@nkr/enums/index';
import { IInvoiceTransplants } from '@nkr/models/index';
import MediaQuery from 'react-responsive';
import { BackgroundTaskInvoices } from './background-task-invoices';

interface IProps {
    list: IInvoiceTransplants[],
    filterRequest: IInvoiceTransplantRequest,
    onSearch: (data: IInvoiceTransplantRequest) => void,
    onSendInvoiceEmail: () => void,
    onGenerateInvoice: () => void,
    onGeneratePreview: () => void,
    onDownloadAll: (invoiceDate) => void,
    onDownloadAllPreviews: (invoiceDate) => void,
    csvExport: (selMonth: string, selYear: string) => void
}

interface IState {
    show: number,
    invoiceYear: string,
    invoiceMonth: string,
    transplantType: InvoiceTransplantStatus,
    organTypes: OrganType[]
}

const initialState: IState = {
    show: 0,
    invoiceYear: moment().add(-1, 'months').year().toString(),
    invoiceMonth: (moment().add(-1, 'months').month() + 1).toString(),
    transplantType: 1,
    organTypes: [OrganType.Kidney, OrganType.Liver]
}

class Filter extends Component<IProps, IState> {
    readonly state = initialState;

    componentDidMount = () => {
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI("sites[]=dash"));
        let parsedOrganType = parsed.organType != null ? parseInt(parsed.organType as string) : null;

        let filterRequest: IInvoiceTransplantRequest = {
            invoiceYear: parsed.invoiceYear != null ? parsed.invoiceYear : moment().add(-1, 'months').year().toString(),
            invoiceMonth: parsed.invoiceMonth != null ? parsed.invoiceMonth : (moment().add(-1, 'months').month() + 1).toString(),
            transplantType: parsed.transplantType != null ? parsed.transplantType : 1,
            organType: parsedOrganType
        }

        this.setState({
            invoiceYear: filterRequest.invoiceYear,
            invoiceMonth: filterRequest.invoiceMonth,
            transplantType: filterRequest.transplantType,
            organTypes: parsedOrganType != null
                ? [parsedOrganType]
                : [OrganType.Kidney, OrganType.Liver]
        });
    }

    handleFieldChange = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputTypeAttribute>) => {
        let { name, value } = e.currentTarget;

        let state = { ...this.state };
        state[name] = value;

        this.setState(state, () => this.handleSearch());
    }

    prevMonth = () => {
        var d = moment(`${this.state.invoiceYear}-${this.state.invoiceMonth}-01`).subtract(1, 'months');

        this.setState({
            invoiceYear: d.year().toString(),
            invoiceMonth: (d.month() + 1).toString()
        }, () => this.handleSearch());
    }

    nextMonth = () => {
        var d = moment(`${this.state.invoiceYear}-${this.state.invoiceMonth}-01`).add(1, 'month');

        this.setState({
            invoiceYear: d.year().toString(),
            invoiceMonth: (d.month() + 1).toString()
        }, () => this.handleSearch());
    }

    handleSearch = () => {
        let { invoiceYear, invoiceMonth, transplantType, organTypes } = this.state;

        let organType = organTypes.length == 2 ? null : organTypes[0];


        let filterRequest: IInvoiceTransplantRequest = {
            invoiceMonth,
            invoiceYear,
            transplantType,
            organType
        };

        this.props.onSearch(filterRequest);
    }

    changeOrganType = (values: OrganType | OrganType[]) => {
        let safeValues = Array.isArray(values) ? values : [values];
        if (safeValues.length == 0) return;
        this.setState({ organTypes: safeValues }, () => this.handleSearch());
    }

    exportCsv = () => {
        this.props.csvExport(this.state.invoiceMonth, this.state.invoiceYear);
    }

    render = () => {
        const months = _.range(1, 13);
        const years = _.range(2008, moment().year() + 1);
        const lastDayPriorMonth = moment().clone().subtract(1, 'months').endOf('month');
        const selectedYear = parseInt(this.state.invoiceYear);
        const selectedMonth = parseInt(this.state.invoiceMonth);
        const allowBulk = this.props.list.filter(x => x.isSelected).length > 0;
        const invoiceDate = moment([selectedYear, selectedMonth - 1, 1]).endOf('month').format("YYYY-MM-DD");
        const isGenMonth = lastDayPriorMonth.format('YYYY-MM-DD') == invoiceDate;
        const hasInvoices = this.props.list.some((invoice) => invoice.id > 0);
        const organValue = this.state.organTypes.length == 2 ? -1 : this.state.organTypes[0];

        return (
            <>
                <FilterWrapper>
                    <Row>
                        <div className="col-xs-12 col-sm-8 col-md-6" style={{marginTop:8}}>
                            <Row>
                                <div className="col-xs-3">
                                    <Button className='btn btn-primary btn-block' onClick={this.prevMonth.bind(this)}>&laquo; prev</Button>
                                </div>
                                <div className="col-xs-3">
                                    <FormControl
                                        className='form-control'
                                        componentClass='select'
                                        name='invoiceMonth'
                                        value={this.state.invoiceMonth}
                                        onChange={this.handleFieldChange}
                                    >
                                        {months.map((month, index) =>
                                            <option key={'mo-' + index} value={month}>{moment.months(month - 1)}</option>
                                        )}
                                    </FormControl>
                                </div>
                                <div className="col-xs-3">
                                    <FormControl
                                        className='form-control'
                                        componentClass='select'
                                        name='invoiceYear'
                                        value={this.state.invoiceYear}
                                        onChange={this.handleFieldChange}
                                    >
                                        {years.map((year, index) =>
                                            <option key={'yr-' + index} value={year}>{year}</option>
                                        )}
                                    </FormControl>
                                </div>
                                <div className="col-xs-3">
                                    <Button className='btn btn-primary btn-block' onClick={this.nextMonth.bind(this)}>next &raquo;</Button>
                                </div>
                            </Row>
                        </div>
                    </Row>
                </FilterWrapper>
                <Row>
                    <div className="col-xs-4 col-lg-3">
                        <h4 style={{ margin: "0 10px 0 0", lineHeight: "1.75em", whiteSpace: 'nowrap' }}>&nbsp;Organ:</h4>
                        <ToggleButtonGroup type='radio' name='organs' value={organValue}>
                            <ToggleButton value={-1} onChange={() => this.changeOrganType([OrganType.Kidney, OrganType.Liver])}
                                className={this.state.organTypes.length == 2 ? 'btn-primary btn-md' : 'btn-md'}>All</ToggleButton>
                            <ToggleButton value={OrganType.Kidney} onChange={() => this.changeOrganType(OrganType.Kidney)}
                                className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Kidney) ? 'btn-primary btn-md' : 'btn-md'}>Kidney</ToggleButton>
                            <ToggleButton value={OrganType.Liver} onChange={() => this.changeOrganType(OrganType.Liver)}
                                className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Liver) ? 'btn-primary btn-md' : 'btn-md'}>Liver</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div className="col-xs-8 col-lg-4">
                        <h4 style={{ margin: "0 10px 0 0", lineHeight: "1.75em", whiteSpace: 'nowrap' }}>&nbsp;</h4>
                        <DropdownButton id="BulkUpdatesButton" bsStyle="primary" title="Bulk File Actions">
                            <MenuItem onClick={this.props.onGeneratePreview}>
                                Generate Previews for {invoiceDate}
                            </MenuItem>
                            <MenuItem onClick={() => this.props.onDownloadAllPreviews(invoiceDate)}>
                                Download Zip of Previews <span className="label label-warning">if generated</span>
                            </MenuItem>
                            {(isGenMonth || hasInvoices) && <li role='separator' className='divider'></li>}
                            {isGenMonth &&
                                <MenuItem onClick={this.props.onGenerateInvoice}>
                                    Generate Invoices for {invoiceDate}
                                </MenuItem>
                            }
                            {hasInvoices &&
                                <MenuItem onClick={() => this.props.onDownloadAll(invoiceDate)}>
                                    Download Zip of Invoices
                                </MenuItem>
                            }
                        </DropdownButton>
                        &nbsp;
                        <Button bsStyle={allowBulk ? "success" : "info"} disabled={!allowBulk} onClick={this.props.onSendInvoiceEmail}>
                            E-Mail Checked
                        </Button>
                        &nbsp;
                        <Button bsStyle="warning" onClick={this.exportCsv}>
                            Export CSV
                        </Button>
                    </div>
                    <div className="col-xs-12 col-lg-5" style={{paddingTop:8}}>
                        <BackgroundTaskInvoices />
                    </div>
                </Row>
            </>
        );
    }
}

export default Filter;